import { useEffect } from "react";
import usePagination from "./usePagination";
import { ISosCdr, ISosCdrIndexParams } from "models/Cdr";
import { indexSosCdr } from "api/issabel/sos";

const useSosCDR = ({
    page: defaultPage,
    pageSize: defaultPageSize,
    startDate,
    endDate,
    dst,
    src,
    assetId,
    disposition
}: ISosCdrIndexParams): ReturnType<typeof usePagination<ISosCdr>> => {

    const hookSosCdr = usePagination<ISosCdr>({ pageSize: defaultPageSize, page: defaultPage });
    const { page, pageSize } = hookSosCdr;

    useEffect(() => {
        const getSosCdr = async () => {
            hookSosCdr.loadingStart();
            const { data, totalItems } = await indexSosCdr({
                page,
                pageSize,
                startDate,
                endDate,
                src,
                dst,
                assetId,
                disposition
            });
            hookSosCdr.setData(data);
            hookSosCdr.setTotalItems(totalItems)
            hookSosCdr.loadingEnd();
        }
        getSosCdr();
    }, [page, pageSize, startDate, endDate, src, dst, assetId, disposition]);

    return hookSosCdr;
}

export default useSosCDR;